import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { Outlet, useLocation } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import styles from "./Layout.styles";
import Header from "../../common/components/header/Header";
import SideBar from "../../common/components/sidebar/SideBar";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import { receiveLPSConfigsRequest } from "../../modules/lps-form/actions";
import { useDispatch } from 'react-redux';
import { drawerWidth } from "../../common/components/lps-menu/LPSMenu";
import { checkGoogleDriveConnectionRequest } from "../../modules/super-admin/actions"
import UserService from '../../common/services/user.service';

const TOKEN_KEY = "token";

const AppInitializer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const lastCheckRef = useRef(0);
  const isLoginPage = useMemo(() =>
    location.pathname.startsWith("/login"), [location.pathname]);

  const checkConnection = useCallback(() => {
    if (isLoginPage) return;
    if (!UserService.token) return;
    const now = Date.now();
    if (now - lastCheckRef.current < 3000) return;
    lastCheckRef.current = now;
    dispatch(checkGoogleDriveConnectionRequest());
  }, [dispatch, isLoginPage]);

  useEffect(() => {
    checkConnection();
  }, [checkConnection, location.pathname]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) checkConnection();
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange)
    }

  }, [checkConnection]);

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key === TOKEN_KEY) checkConnection();
    };
    const onTokenChange = () => {
      checkConnection();
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener('auth:token', onTokenChange);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('auth:token', onTokenChange);
    }
  }, [checkConnection]);

  return null;
  // const isLoginPage = location.pathname.startsWith('/login');
  //
  // // useEffect (() => {
  // //   if (!isLoginPage) {
  // //     // console.log("[INIT] Checking token...");
  // //
  // //     dispatch(checkGoogleDriveConnectionRequest());
  // //   }
  // //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // // }, []);
  //
  // useEffect (() => {
  //   if (isLoginPage) return;
  //   if (!UserService.token) return;
  //     // console.log("[Route Change] Checking token...");
  //     dispatch(checkGoogleDriveConnectionRequest());
  // }, [location.pathname, isLoginPage, dispatch]);
  //
  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.hidden) return;
  //     if (isLoginPage) return;
  //     if (!UserService.token) return;
  //     // console.log('[Visibility] Checking token... ');
  //     dispatch(checkGoogleDriveConnectionRequest());
  //   }
  //   document.addEventListener('visibilitychange', handleVisibilityChange);
  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange)
  //   }
  // },[dispatch, isLoginPage]);
  //
  // return null;
}

const Main = styled("main", {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "lpsMenuOpen",
})<{
  open?: boolean;
  lpsMenuOpen?: boolean;
}>(({ theme, open, lpsMenuOpen }) => ({
  width: "100%",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),

  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
  ...(lpsMenuOpen && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: `${drawerWidth}px`,
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  padding: 0,
  alignItems: "center",
  ...theme.mixins.toolbar,
}));

const Layout = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [lpsMenuOpen, setLpsMenuOpen] = useState(false);

  const setLPSMenuOpen = () => {
    setLpsMenuOpen(!lpsMenuOpen);
    if (!lpsMenuOpen) {
      dispatch(receiveLPSConfigsRequest());
    }
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={styles.layoutWrapper}>
      <CssBaseline />
      <Header
        drawerOpen={handleDrawerOpen}
        drawerLPSOpen={setLPSMenuOpen}
        lpsMenuOpen={lpsMenuOpen}
        open={open}
      />
      <SideBar
        //@ts-ignore
        drawerClose={handleDrawerClose}
        open={open}
      />
      <Main open={open} lpsMenuOpen={lpsMenuOpen}>
        <DrawerHeader />
        <AppInitializer />
        <Outlet />
      </Main>
    </Box>
  );
};

export default Layout;
